/**
 * 产品更多详情：区块内视频进入视口后异步加载并自动循环播放
 */
(function () {
  function loadAndPlayVideo(videoEl) {
    if (!videoEl || videoEl.getAttribute('data-video-loaded') === 'true') {
      return;
    }

    var videoSrc = videoEl.getAttribute('data-video-src');
    if (!videoSrc) {
      return;
    }

    var videoType = videoEl.getAttribute('data-video-type') || 'video/mp4';

    if (!videoEl.querySelector('source')) {
      var source = document.createElement('source');
      source.src = videoSrc;
      source.type = videoType;
      videoEl.appendChild(source);
    }

    var wrap = videoEl.closest('.product-more-details__video-wrap');
    var soundBtn = wrap && wrap.querySelector('[data-product-more-details-sound]');
    var userEnabledSound = soundBtn && soundBtn.getAttribute('aria-pressed') === 'true';
    if (!userEnabledSound) {
      setVideoMuted(videoEl, true);
    }
    videoEl.loop = true;
    videoEl.playsInline = true;
    videoEl.setAttribute('playsinline', '');
    videoEl.preload = 'auto';

    function tryPlay() {
      var playPromise = videoEl.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    videoEl.addEventListener(
      'loadeddata',
      function () {
        tryPlay();
        syncSoundAfterVideoLoad(videoEl);
      },
      { once: true }
    );
    videoEl.setAttribute('data-video-loaded', 'true');
    videoEl.load();
  }

  /** 设置视频静音（同步 muted 属性，避免仅改 property 无效） */
  function setVideoMuted(videoEl, muted) {
    videoEl.muted = muted;
    if (muted) {
      videoEl.setAttribute('muted', '');
    } else {
      videoEl.removeAttribute('muted');
    }
  }

  /** 同步静音按钮与视频状态（图标由 aria-pressed + CSS 切换） */
  function syncSoundButton(videoEl, soundBtn) {
    var labelUnmute = soundBtn.getAttribute('data-label-unmute') || 'Turn on sound';
    var labelMute = soundBtn.getAttribute('data-label-mute') || 'Turn off sound';
    var isMuted = videoEl.muted;

    soundBtn.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
    soundBtn.setAttribute('aria-label', isMuted ? labelUnmute : labelMute);
  }

  /** 绑定静音切换 */
  function initSoundToggle(wrap) {
    var videoEl = wrap.querySelector('[data-product-more-details-video]');
    var soundBtn = wrap.querySelector('[data-product-more-details-sound]');
    if (!videoEl || !soundBtn) {
      return;
    }

    syncSoundButton(videoEl, soundBtn);

    soundBtn.addEventListener('click', function () {
      var nextMuted = !videoEl.muted;
      setVideoMuted(videoEl, nextMuted);

      if (!nextMuted) {
        if (videoEl.paused) {
          var playPromise = videoEl.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }
        videoEl.volume = 1;
      }

      syncSoundButton(videoEl, soundBtn);
    });
  }

  /** 视频懒加载后恢复按钮与静音状态一致 */
  function syncSoundAfterVideoLoad(videoEl) {
    var wrap = videoEl.closest('.product-more-details__video-wrap');
    if (!wrap) {
      return;
    }
    var soundBtn = wrap.querySelector('[data-product-more-details-sound]');
    if (soundBtn) {
      syncSoundButton(videoEl, soundBtn);
    }
  }

  function initSection(sectionRoot) {
    var videoWraps = sectionRoot.querySelectorAll('.product-more-details__video-wrap');
    videoWraps.forEach(initSoundToggle);

    var videos = sectionRoot.querySelectorAll('[data-product-more-details-video]');
    if (!videos.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadAndPlayVideo);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }
          loadAndPlayVideo(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '120px', threshold: 0.15 }
    );

    videos.forEach(function (videoEl) {
      observer.observe(videoEl);
    });
  }

  function boot() {
    document.querySelectorAll('.product-more-details').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
